Revolution.Module.extend({
    NAME: "mde.generate-pdf", // OBLIGATOIRE (reflète l'arborescence répertoire : /mde/generate-pdf.js)

    initialize: function ($) {
        // appelé aussitôt la page chargée
        //console.log("module " + this.NAME);

        //_.bindAll(this, "equalheight", "runEqualHeight", "getHeightsForOffsets");

        //events

        this.generatePDF();

    },

    onWindowLoad: function (e) {

    },

    onWindowScroll: function (e) {

    },
    onWindowResize: function (e) {

    },

    generatePDF: function () {

        $('.js-btn-export').on('click', function (e) {
            e.preventDefault();
            //$(e.currentTarget).closest('.sidebar-content-wrapper').find('.js-btn-toggle').click();

            $('.bk-map-loader').first().fadeIn();
            $('body').addClass('pdf-styled');
            var lang = $('html').attr('lang');
            var dateOptions = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
            var date = new Date();
            $('.day-date').html(date.toLocaleDateString("fr-FR", dateOptions));
            
            if (lang !== 'fr') {
                $('.day-date').html(date.toLocaleDateString("en-EN", dateOptions));
            }

            html2canvas(document.body, {
                imageTimeout: 0,
                allowTaint: true,
                useCORS: true,
                width: 1300,
                windowWidth: 1300
            }).then(function(canvas) {
                var imgData = canvas.toDataURL('image/png');
                var imgWidth = 210;
                var pageHeight = 295;
                var imgHeight = canvas.height * imgWidth / canvas.width;
                var heightLeft = imgHeight;

                var doc = new jsPDF('p', 'mm');
                var position = 0;

                doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
                heightLeft -= pageHeight;

                while (heightLeft >= 0) {
                  position = heightLeft - imgHeight;
                  doc.addPage();
                  doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
                  heightLeft -= pageHeight;
                }
                doc.save( 'file.pdf');
                $('body').removeClass('pdf-styled');
                $('.bk-map-loader').first().fadeOut();

            });
        });
    }

});
